import type { DateRange } from "@/hooks/useDateRange";
import { useParams } from "react-router-dom";
import { useHotel } from "@/hooks/useHotel";
import { useSelectedHotelId } from "@/utils/hotelContext";
import { toAnalyticsDateParam } from "../utils/analyticsDateUtils";

export type AnalyticsOverviewSkipReason =
  | "missing-hotel-id"
  | "missing-from-date"
  | "missing-to-date";

export function useAnalyticsOverviewRange(dateRange: DateRange) {
  const { hotelId: routeHotelId } = useParams<{ hotelId?: string }>();
  const selectedHotelId = useSelectedHotelId();
  const { hotelId: userHotelId } = useHotel();
  const hotelId = routeHotelId ?? selectedHotelId ?? userHotelId ?? null;
  const from = toAnalyticsDateParam(dateRange.from);
  const to = toAnalyticsDateParam(dateRange.to);

  const skipReasons: AnalyticsOverviewSkipReason[] = [];
  if (!hotelId) {
    skipReasons.push("missing-hotel-id");
  }
  if (!from) {
    skipReasons.push("missing-from-date");
  }
  if (!to) {
    skipReasons.push("missing-to-date");
  }

  const isReady = skipReasons.length === 0;

  return {
    hotelId: hotelId ?? "",
    from: from ?? "",
    to: to ?? "",
    isReady,
    skipReasons,
  };
}
